export const GENERIC_RESPONSE = {
  "dado": [
    {
      "cnpj": "02036483000614",
      "razaoSocial": "KXMVQMHMVWD NX OIWUQD FIXNGVXU WGVXPXVQEXU DVNW",
      "situacaoEmpresa": "Ativa",
      "tipoParticipacao": "Responsável",
      "dataInicio": "2024-01-18"
    },
    {
      "cnpj": "02036483000614",
      "razaoSocial": "KXMVQMHMVWD NX OIWUQD FIXNGVXU WGVXPXVQEXU DVNW",
      "situacaoEmpresa": "Ativa",
      "tipoParticipacao": "Sócio",
      "dataInicio": "2016-06-21"
    }
  ],
  "errors": []
};
